import React, { useEffect } from 'react';
import { useTypedSelector } from '@Features/store';
import { useHistory } from 'react-router-dom';
import AddVideoInfo from './Components/AddVideoInfo';
import { useUnitPermissions } from '@Pages/ClassRooms/Pages/SingleCourse/Pages/CourseForm/Pages/CourseContent/useUnitPermissions';

const AddVideo = () => {
	const { currentCourse } = useTypedSelector((state) => state.classroom);
	const { canCreate } = useUnitPermissions();
	const history = useHistory();

	useEffect(() => {
		if (!canCreate) history.goBack();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!canCreate) return null;

	return <>{currentCourse && <AddVideoInfo />}</>;
};

export default AddVideo;
